import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, NgZone, Renderer2 } from '@angular/core';

import { GridDataResult, DataStateChangeEvent, PageChangeEvent, SelectionEvent, GridComponent } from '@progress/kendo-angular-grid';
import { SortDescriptor, process, State } from '@progress/kendo-data-query';
import { sortBy } from 'sort-by-typescript';

// Models
import { ContractorDetailsModel, ContractorConfigurationModel, ValidationModel } from '../../models/contractordetailsmodel';
import { PasswordValidationModel, EmailValidationModel, WebSiteUrlValidationModel, UserNameValidationModel } from '../../models/common-validation.model';
import { AppenateCreateUserModel, AppenateDeleteUserModel } from '../../models/appenate-createuser.model';
import { NotificationModel } from '../../models/notification.model';

// Services
import { ContractorDetailsService } from '../../services/contractor-details.service';
import Swal from 'sweetalert2';
import { ClientService } from '../../services/client.service';
import { AuthService } from '../../services/auth.service';
import { AppCode } from '../../../app.code';
import { ExcelExportData } from '@progress/kendo-angular-excel-export';

@Component({
  selector: 'app-contractor-setup',
  templateUrl: './contractor-setup.component.html',
  styleUrls: ['./contractor-setup.component.css']
})
export class ContractorSetupComponent implements OnInit {
  state: State =
    {
      skip: 0,
      take: 100,
      filter: {
        logic: 'and',
        filters: []
      }
    }

  @Input() public contractorConfiguration: ContractorConfigurationModel = new ContractorConfigurationModel();
  @Output() public outpkTableId = new EventEmitter<string>();
  userRoles: string = "";
  clientId: string = "";
  userEmail: string = "";
  selectedFile: File = null;
  base64textString: String = "";
  contModel: ContractorDetailsModel = new ContractorDetailsModel();
  contModelOldData: ContractorDetailsModel = new ContractorDetailsModel();
  validationModel: ValidationModel;
  loading: boolean = false;
  isValidForm: boolean = null;
  isDisable: boolean = true;
  Id: string = "";
  gridHeight: number = 640;
  gridRowCount: number = 0;
  client: any = {};
  skip: number = 0;
  pageSize: number = 100;
  ContractorId: number = 0;
  contractorList = [];
   uniqueContractors = [];
  public sort: SortDescriptor[] = [];
  public gridView: GridDataResult;
  btnName: string = "SUBMIT";
  addEditFormName: string = "";
  showModal: boolean = false;
  errors: string;
  model: any = {};
  isShown: boolean = false;
  Email: string = "";
  CompanyId: number = 0;
  IntegrationKey: string = "";
  length: number = 0;

  selectContractorSectionShowModal: boolean = false;
  selectContractorSectionShowModalClass: string = "modal fade";
  hideSelectDetailSection: boolean = false;
  emailLabelText: string = "Contractor Email";
  reportEmailLabel: string = "Report Email";
  passwordLabelText: string = "Password for Web-Login";

  @ViewChild('contractorPanelAddEdit') contractorPanelAddEditRef: ElementRef;
  @ViewChild('contractorFormModalPopup') public contractorFormModalPopupRef: ElementRef;


  @ViewChild('panelGridModalPopupContractor') panelGridModalPopupRef: ElementRef;
  @ViewChild('panelGridContractor') public panelGridRef: ElementRef;

  password: string = "";
  loginFieldsDisabled: boolean = false;
  passwordFieldsDisabled: boolean = false;
  passwordValidationModel: PasswordValidationModel = new PasswordValidationModel();
  emailValidationModel: EmailValidationModel = new EmailValidationModel();
  webSiteUrlValidationModel: WebSiteUrlValidationModel = new WebSiteUrlValidationModel();
  userNameValidationModel: UserNameValidationModel = new UserNameValidationModel();
  appenateCreateUser: AppenateCreateUserModel = new AppenateCreateUserModel();
  appenateDeleteUser: AppenateDeleteUserModel = new AppenateDeleteUserModel();

  constructor(private clientService: ClientService, private contractorDetailsService: ContractorDetailsService,
    private renderer: Renderer2, private authService: AuthService,
    private appCode: AppCode) {
    this.client = this.clientService.getClient();
    this.showModal = (!this.contractorConfiguration.addEditInModalPopUp) ? true : this.showModal;
    this.allData = this.allData.bind(this);

  }

  openAddEditInModlalPopup() {
    this.onClearFields();
    this.showModal = true;
    this.addEditFormName = this.contractorConfiguration.addFormName;
    if (this.contractorConfiguration.addEditInModalPopUp) {
      this.showModal = true;
    }
    else {
      this.appCode.scrollTo("panelAddEdit");
    }
  }

  closeAddEditModlalPopup() {
    this.onClearFields();
    this.showModal = false;
  }

  ngOnInit() {
    //Clear Fields
    //this.loading = true;
    this.onClearFields();

    // Get Contractor List
    this.bindData();

    //Get User Data From Appenate
    this.GetUserDataFromAppenate();


    // Set Grid Height
    this.setGridHeight();
    //this.loading = false;
  }

  ngAfterViewInit() {
    if (this.contractorConfiguration.addEditInModalPopUp) {
      this.renderer.appendChild(this.contractorFormModalPopupRef.nativeElement, this.contractorPanelAddEditRef.nativeElement);
    }
    if (this.contractorConfiguration.selectContractorSection) {
      this.renderer.appendChild(this.panelGridModalPopupRef.nativeElement, this.panelGridRef.nativeElement);
    }
  }

  setGridHeight() {
    var windowHeight = window.innerHeight;
    this.gridHeight = windowHeight; /*- 230;*/
    this.gridRowCount = this.gridView != undefined ? this.gridView.total : 0;
  }

  public dataStateChange(state: DataStateChangeEvent): void {
    this.state = state;
    this.gridView = process(this.contractorList, this.state);
  }

  public exportToExcel(grid: GridComponent): void {
    grid.saveAsExcel();
  }
  // Bind All Data for excel Method
  public allData(): ExcelExportData {
    const result: ExcelExportData = {
      data: process(this.contractorList, {
      }).data,
    };
    return result;
  }
  // Get All Contractor Details
  async getContractorList(clientID: string, userrole: string, userEmail: string) {

    //Global filter
    var globalFilterCondition = await this.appCode.getGlobalFilterCondition();

    var congractorList = await this.contractorDetailsService.getContractor(clientID, userrole, userEmail, globalFilterCondition);
    var congractorListParse = JSON.stringify(congractorList);
    congractorListParse = JSON.parse(congractorListParse);
    if (congractorListParse != null && congractorListParse.length == 1) {
      this.contractorConfiguration.selectedValueContractorDropDownList = congractorListParse[0]["tblContractorId"];
      this.outpkTableId.emit(congractorListParse[0]["tblContractorId"]);
    }
    return await congractorList;
  }



  public async GetUserDataFromAppenate() {

    this.IntegrationKey = "fedc934ce4124c5d92741eaa2805a7df&&&&&&&&";
    this.CompanyId = this.contractorConfiguration.appenateCreateUser.companyId;
    var congractorList = await this.contractorDetailsService.GetUserDataFromAppenate(this.CompanyId, this.IntegrationKey);

  }


  bindData() {
    this.loading = true;
    this.userRoles = localStorage.getItem("Roles");

    let user = localStorage.getItem("currentUser");
    let jouser = JSON.parse(user);
    this.userEmail = jouser.user.Email;
    this.clientId = jouser.user.ClientId;
    if (this.contractorConfiguration.displayListCardView || this.contractorConfiguration.displayContractorDropDownList) {

      this.getContractorList(this.clientId, this.userRoles, this.userEmail).then(async (data: any) => {
        this.contractorList = await data;
        // Create an object to keep track of which contractors have already been added
        const contractorMap = {};
        // Iterate through the contractorList
        for (const contractor of this.contractorList) {
          const tblContractorId = contractor.tblContractorId;
          const contractorName = contractor.contractorName;
          // Check if the contractor has not been added to the uniqueContractors list
          if (!contractorMap[tblContractorId]) {
            // Add the contractor to the uniqueContractors list
            this.uniqueContractors.push({ tblContractorId: tblContractorId, contractorName: contractorName });
            // Mark the contractor as added in the contractorMap
            contractorMap[tblContractorId] = true;
          }
        }
        if (!this.contractorConfiguration.displayContractorDropDownList) {
          this.gridView = process(this.contractorList, this.state);
          this.gridRowCount = this.gridView.total;
        }
        else {
          this.contractorList = this.contractorList.sort(sortBy('contractorName^'));
        }
        this.loading = false;
      });
    }
  
    
  }

  // Submit Process
  async onSubmitForm() {
    if (this.btnName == "UPDATE" && this.contModel.tblContractorId == 0) {
      Swal.fire({
        title: 'Contractor',
        text: 'Please select contractor record for Edit.',
      }).then((result) => {
        if (result.value === true) {
          this.appCode.scrollTo('panelGrid');
        } else if (result.dismiss) {
          this.appCode.scrollTo('panelGrid');
        }
      });

      return true;
    }
    this.loading = true;    
    var result = await this.validateFormData();

    if (result != null && result != undefined) {
      if (result == true) {
        this.callSubmitMethod();
      }
      else {
        this.loading = false;
      }
    }
    else {
      this.loading = false;
    }
  }
  callSubmitMethod() {

    this.onSubmit().then(async (data) => {
      Swal.fire({
        text: (this.contModel.tblContractorId == 0 ? "Contractor Details Saved Successfully" : "Contractor Details Saved Successfully"),
        confirmButtonText: 'Ok',
        confirmButtonColor: '#3085d6',
        allowOutsideClick: true
      }).then((result) => {
        // Get All Contractor Details
        this.bindData();
        this.onClearFields();
        //this.getContractorDataById(contractorId);
        this.loading = false;
        this.appCode.scrollTo('panelGrid');
        if (this.contractorConfiguration.addEditInModalPopUp) {
          this.closeAddEditModlalPopup();
        }
      });
    });
  }
  async onSubmit() {
    this.loading = true;
    //if tblContractorId == 0 then new Contractor else Edit Contractor
    var tblContractorId = this.contModel.tblContractorId;

    //insert/update contractor data
    var contractorId = await this.insertUpdateContractorData();
    this.contModel.tblContractorId = parseInt(contractorId.toString());
    this.ContractorId = this.contModel.tblContractorId;
    var changedLoginOption = false;


    this.appenateCreateUser = new AppenateCreateUserModel();
    this.appenateCreateUser = this.contractorConfiguration.appenateCreateUser;

    this.appenateCreateUser.firstName = "";
    var splitContractorName = this.contModel.contractorName.split(' ');
    //this.appenateCreateUser.firstName = splitContactPersonName[0];

    // if (splitContractorName.length == 1) {
    //   this.appenateCreateUser.firstName = splitContractorName[0];
    //   this.appenateCreateUser.lastName = splitContractorName[0];
    // }
    // else {
    //   this.appenateCreateUser.lastName = splitContractorName.length > 1 ? splitContractorName[splitContractorName.length - 1] : splitContractorName[0];
    //   for (length = 0; length < splitContractorName.length - 1; length++) {
    //     this.appenateCreateUser.firstName = this.appenateCreateUser.firstName + ' ' + splitContractorName[length];
    //   }
    // }

    if (splitContractorName.length == 1) {
      this.appenateCreateUser.firstName = splitContractorName[0];
      this.appenateCreateUser.lastName = splitContractorName[0];
    }
    else{
    // Assign the last name (always the last element in the array)
    this.appenateCreateUser.lastName = splitContractorName[splitContractorName.length - 1];

    // Assign the first name (everything except the last element)
    this.appenateCreateUser.firstName = splitContractorName.slice(0, -1).join(' ');
    }

    this.appenateCreateUser.firstName = this.appenateCreateUser.firstName.trim();
    this.appenateCreateUser.email = this.contModel.contractorEmail;
    this.appenateCreateUser.password = this.password;

    //create appenate user
    if (this.contModel.appenateUser == "Yes" && (this.contModel.appenateUserId == "" || this.contModel.appenateUserId == null)) {
      var result = await (await this.appCode.createAppenateUser(this.appenateCreateUser));
      this.contModel.appenateUserId = result["id"];
      changedLoginOption = true;
    }
    // update appenate user details
    else if (this.contModel.appenateUser == "Yes" && (this.contModel.appenateUserId != "" && this.contModel.appenateUserId != null)) {
      //var result = await (await this.appCode.updateAppenateUser(this.appenateCreateUser));
    }
    else if (this.contModel.appenateUser == "No" && (this.contModel.appenateUserId != "" && this.contModel.appenateUserId != null)) {
      this.loading = true;
      this.appenateDeleteUser = new AppenateDeleteUserModel();
      this.appenateDeleteUser.integrationKey = this.contractorConfiguration.appenateCreateUser.integrationKey;
      this.appenateDeleteUser.companyId = this.contractorConfiguration.appenateCreateUser.companyId;
      this.appenateDeleteUser.id = this.contModel.appenateUserId;
      this.appCode.deleteAppenateUser(this.appenateDeleteUser); // delete employee
      this.contModel.appenateUserId = "";
      this.contModel.appenateUser = "No";
      changedLoginOption = true;
      this.loading = false;
    }

    //create webapp user
    //if ((this.contModel.webLogin == "Yes" && this.contModelOldData.webLogin == "No"))
    if (this.contModel.webLogin == "Yes" && (this.contModel.userId == "" || this.contModel.userId == null)) {
      var userData: any = {
        userName: this.contModel.contractorEmail, email: this.contModel.contractorEmail, password: this.password,
        firstName: this.contModel.contractorName, lastName: "", isActive: true
      };
      this.contModel.userId = await this.appCode.createUser(userData, this.contractorConfiguration.contractorRoles, false);
      changedLoginOption = true;
    }
    else if (this.contModel.webLogin == "No" && (this.contModel.userId == "" || this.contModel.userId == null)) {
      //Need to create user in web-login - to insert record in dbo.user table to get user's data for emailNotification - but keep isActive should false.
      //var userData: any = { userName: this.contModel.contractorEmail, email: this.contModel.contractorEmail, password: this.password,
      //                    firstName: this.contModel.contractorName, lastName: "", isActive:false };
      //this.contModel.userId = await this.appCode.createUser(userData, this.contractorConfiguration.contractorRoles, false);
      //changedLoginOption = true;
    }
    else if (this.contModel.webLogin == "No" && (this.contModel.userId != "" && this.contModel.userId !== null))//In Edit - when user change weblogin - 'yes' to 'no'
    {
      //Deactivate user
      this.loading = true;
      this.appCode.deactivateUser(this.contModel.userId);
      this.loading = false;
    }

    //send email notification
    if (changedLoginOption) {
      contractorId = await this.insertUpdateContractorData();

      var notificationModel = new NotificationModel();
      if ((this.contModel.webLogin == "Yes" && this.contModelOldData.webLogin == "No") &&
        (this.contModel.appenateUser == "Yes" && this.contModelOldData.appenateUser == "No")) {
        notificationModel.emailFor = "webmobile";
      }
      else if (this.contModel.webLogin == "Yes" && this.contModelOldData.webLogin == "No") {
        notificationModel.emailFor = "web";
      }
      else if (this.contModel.appenateUser == "Yes" && this.contModelOldData.appenateUser == "No") {
        notificationModel.emailFor = "mobile";
      }
      if (notificationModel.emailFor != "") {
        notificationModel.clientId = this.client.clientId;
        notificationModel.userId = this.contModel.userId;
        notificationModel.email = this.contModel.contractorEmail;
        notificationModel.password = this.password;
        notificationModel.contractorId = contractorId.toString();
        notificationModel.employeeId = "0";

        var notificationResult = await this.appCode.sendVerificationEmailToUserAndAdmin(notificationModel);
      }
    }
  }

  async insertUpdateContractorData() {
    this.client = this.clientService.getClient();
    if (this.client != null) {
      this.contModel.ClientId = this.client.clientId;
    }
    this.contModel.FormId = this.contractorConfiguration.formId;
    this.contModel.autoGenerateCode = this.contractorConfiguration.autoGenerateContractorCode;
    if (this.ContractorId == 0) {
      this.contModel.createdBy = this.appCode.getCurrentUserName();
    }
    else {
      this.contModel.updatedBy = this.appCode.getCurrentUserName();
    }
    var data = await this.contractorDetailsService.postContractorDetails(this.contModel, 'AddUpdateContractorDetailsData');
    return data;
  }

  onResize() {
    this.setGridHeight();
  }

  openAddContractor() {
    this.onClearFields();
    this.addEditFormName = this.contractorConfiguration.addFormName;
    this.appCode.scrollTo('panelAddEdit');
  }

  onClearFields() {
    this.ContractorId = 0;
    this.outpkTableId.emit("0");
    this.contModel.contractorName = "";
    this.contModel.contactPersonName = "";
    this.contModel.contractorEmail = "";
    this.contModel.contractorTelephone1 = "";
    this.contModel.contractorTelephone2 = "";
    this.contModel.contractorWebsite = "";
    this.contModel.contractorCode = "";
    this.contModel.webLogin = "No";
    this.contModel.appenateUser = "No";
    this.contModel.appenateUserId = null;
    this.contModel.userId = "";
    this.password = "";
    this.loginFieldsDisabled = false;
    this.contModel.contractorLogo = "../../../../assets/img/no-photo-available.png";
    this.contModel.tblContractorId = 0;
    if (this.contractorConfiguration.allowAdd) {
      this.btnName = "SUBMIT";
      this.addEditFormName = "Add Contractor";
    }
    else if (this.contractorConfiguration.allowEdit) {
      this.btnName = "UPDATE";
      this.addEditFormName = "Edit Contractor";
    }

    this.emailLabelText = "Contractor Email";
    this.passwordLabelText = "Password for Web-Login";
    this.validationModel = new ValidationModel();
    this.emailValidationModel = new EmailValidationModel();
    this.passwordValidationModel = new PasswordValidationModel();
    this.webSiteUrlValidationModel = new WebSiteUrlValidationModel();
    this.userNameValidationModel = new UserNameValidationModel();
    this.contModel.reportEmail = "";
    this.reportEmailLabel = "Report Email";

    this.contModelOldData = new ContractorDetailsModel();
  }

  onUploadChange(evt: any) {
    var files = evt.target.files;
    var file = files[0];
    if (files && file) {
      var reader = new FileReader();
      reader.onload = this._handleReaderLoaded.bind(this);
      reader.readAsBinaryString(file);
    }
  }

  _handleReaderLoaded(readerEvt) {
    var binaryString = readerEvt.target.result;
    this.base64textString = 'data:image/png;base64,' + btoa(binaryString);
    this.contModel.contractorLogo = this.base64textString.toString();
  }

  public sortChange(sort: SortDescriptor[]): void {
    this.sort = sort;
  }

  // To Apply Validation Form
  async validateFormData() {
    this.validationModel
    if (this.contractorConfiguration.requiredFeilds.contractorCode && !this.contractorConfiguration.autoGenerateContractorCode && this.contModel.contractorCode == "") {
      this.validationModel.isContractorCodeValid = false;
      this.validationModel.ContractorCodeValidationMessage = "Contractor Code is required.";
    }
    else {
      this.validationModel.isContractorCodeValid = true;
    }
    if (this.validationModel.isContractorCodeValid && !this.contractorConfiguration.autoGenerateContractorCode) {
      var checkContractorExists = this.contractorList.find(f => f.contractorCode.toLowerCase() == this.contModel.contractorCode.toLowerCase());
      if (checkContractorExists && checkContractorExists.tblContractorId != this.ContractorId) {
        this.validationModel.isContractorCodeValid = false;
        this.validationModel.ContractorCodeValidationMessage = "Contractor Code already exists.";
      }
      else {
        this.validationModel.isContractorNameValid = true;
      }
    }
    this.validationModel.isContractorNameValid = this.contractorConfiguration.requiredFeilds.contractorName && this.contModel.contractorName == "" ? false : true;
    if (this.validationModel.isContractorNameValid) {
      var checkContractorExists = this.contractorList.find(f => f.contractorName.toLowerCase() == this.contModel.contractorName.toLowerCase());
      if (checkContractorExists && checkContractorExists.tblContractorId != this.ContractorId) {
        this.validationModel.isContractorNameValid = false;
        this.validationModel.ContractorNameValidationMessage = "Contractor Name already exists.";
      }
      else {
        this.validationModel.isContractorNameValid = true;
      }
    }
    else {
      this.validationModel.ContractorNameValidationMessage = "Contractor Name is required.";
    }

    this.validationModel.isContactPersonNameValid = this.contractorConfiguration.requiredFeilds.contactPersonName && this.contModel.contactPersonName == "" ? false : true;
    this.validationModel.isContractorTelephone1Valid = this.contractorConfiguration.requiredFeilds.contractorTelephone1 && this.contModel.contractorTelephone1 == "" ? false : true;
    this.validationModel.isContractorTelephone2Valid = this.contractorConfiguration.requiredFeilds.contractorTelephone2 && this.contModel.contractorTelephone2 == "" ? false : true;
    this.validationModel.isContractorLogoValid = this.contractorConfiguration.requiredFeilds.contractorLogo && this.contModel.contractorLogo == "" ? false : true;

    this.webSiteUrlValidationModel = await this.appCode.onWebsiteUrlValidation(this.contModel.contractorWebsite, this.contractorConfiguration.requiredFeilds.contractorWebsite);
    this.emailValidationModel = this.appCode.onEmailValidation(this.contModel.contractorEmail, this.contractorConfiguration.requiredFeilds.contractorEmail);
    this.passwordValidationModel = (this.passwordFieldsDisabled == false && (this.contModel.webLogin == "Yes" || this.contModel.appenateUser == "Yes")) ? await this.appCode.onPasswordValidation(this.password, true) : new PasswordValidationModel();

    if (!this.validationModel.isContractorNameValid || !this.validationModel.isContactPersonNameValid
      || !this.validationModel.isContractorTelephone1Valid
      || !this.validationModel.isContractorTelephone2Valid
      || !this.validationModel.isContractorLogoValid
      || !this.emailValidationModel.isEmailIdValid
      || !this.passwordValidationModel.isPasswordValid
      || !this.webSiteUrlValidationModel.isValid
      || !this.validationModel.isContractorCodeValid
    ) {
      this.isValidForm = false;
    }
    else {
      this.isValidForm = true;
    }

    //appenate user validation - check user exists in appenate
    if (this.contModel.appenateUser == "Yes" && (this.contModel.appenateUserId == "" || this.contModel.appenateUserId == null)) {
      this.appenateCreateUser = new AppenateCreateUserModel();
      this.appenateCreateUser = this.contractorConfiguration.appenateCreateUser;

      this.CompanyId = this.appenateCreateUser.companyId;
      this.IntegrationKey = this.appenateCreateUser.integrationKey;
      this.Email = this.contModel.contractorEmail;

      // to check user exist on appenate
      this.userNameValidationModel = await this.appCode.checkUserNameExistsInAppenate(this.CompanyId, this.IntegrationKey, this.Email);
      if (!this.isValidForm || !this.userNameValidationModel.isValid) {
        this.isValidForm = false;
        return this.isValidForm;
      }
    }

    if (this.contModel.webLogin == "Yes" && !this.loginFieldsDisabled && this.emailValidationModel.isEmailIdValid) {
      this.userNameValidationModel = await this.appCode.checkUserNameExists(this.contModel.contractorEmail, this.contModel.userId);
      if (!this.isValidForm || !this.userNameValidationModel.isValid) {
        this.isValidForm = false;
        return this.isValidForm;
      }
      //return await this.isValidForm;
    }

    var confirmationMsg = "";
    if (this.contModel.appenateUser == "No" && (this.contModel.appenateUserId != "" && this.contModel.appenateUserId != null)) {
      confirmationMsg = 'This action will deactivate mobile-app';
    }

    if (this.contModel.webLogin == "No" && (this.contModel.userId != "" && this.contModel.userId != null)) {
      confirmationMsg = confirmationMsg != "" ? confirmationMsg + ' and web-app login.' : 'This action will deactivate web-app login.';
    }

    if (confirmationMsg != "") {
      this.loading = true;
      Swal.fire({
        title: 'Are you sure?',
        text: confirmationMsg,
        showCancelButton: true,
        confirmButtonText: 'Ok',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'No',
        allowOutsideClick: false
      }).then((result) => {
        if (result.value != undefined && result.value == true) {
          this.callSubmitMethod();
          return this.isValidForm;
        }
        else if (result.dismiss != undefined && (result.dismiss.toString() == "cancel")) {
          this.isValidForm = false;
          return this.isValidForm;
        }
      });
    }
    else {
      return await this.isValidForm;
    }

  }

  // ACTION - DELETE
  onDelete(webUserId, appenateUserId, contId, type) {
    this.ContractorId = parseInt(contId);

    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to delete this contractor?',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      cancelButtonText: 'No',
      allowOutsideClick: false
    }).then((result) => {
      if (result.value === true) {
        this.loading = true;
        this.contractorDetailsService.deleteContractorDetails(this.ContractorId, type)
          .then(() => {
            if (appenateUserId != null && appenateUserId != "") {
              this.appenateDeleteUser = new AppenateDeleteUserModel();
              this.appenateDeleteUser.integrationKey = this.contractorConfiguration.appenateCreateUser.integrationKey;
              this.appenateDeleteUser.companyId = this.contractorConfiguration.appenateCreateUser.companyId;
              this.appenateDeleteUser.id = appenateUserId;
              this.appCode.deleteAppenateUser(this.appenateDeleteUser);
            }

            if (webUserId != null && webUserId != "") {
              this.appCode.deactivateUser(webUserId);
            }
            this.bindData();
          }, (error) => {
            console.error("Error:   " + JSON.stringify(error));
            this.loading = false;
          });
        this.loading = false;
      }
      else if (result.dismiss) {
        // Get All Contractor Details
        //this.bindData();
        this.loading = false;
      }
    });
  }

  onEdit(contId) {
    //this.userRoles = localStorage.getItem("Roles");
    /* if (this.userRoles.toLowerCase() == 'leaklogiccontractor') {*/
    //this.appCode.scrollTo('modalADDADDRESS')
    //}
    //else {
    this.appCode.scrollTo('panelAddEdit');
    //}
    this.loading = true;
    this.getContractorDataById(contId);
  }

  async getContractorDataById(contId) {
    this.loading = true;
    this.ContractorId = parseInt(contId);
    var contractorLogo = "";
    this.addEditFormName = this.contractorConfiguration.editFormName;
    this.contractorDetailsService.getContractorDetails(this.ContractorId).then((data: any) => {
      if (data[0]) {
        contractorLogo = (data[0].contractorLogo != null && data[0].contractorLogo != "" ? data[0].contractorLogo : "../../../../assets/img/no-photo-available.png");
        this.contModel.tblContractorId = data[0].tblContractorId;
        this.contModel.contractorName = data[0].contractorName;
        this.contModel.contactPersonName = data[0].contactPersonName;
        this.contModel.contractorEmail = data[0].contractorEmail;
        this.contModel.contractorTelephone1 = data[0].contractorTelephone1;
        this.contModel.contractorTelephone2 = data[0].contractorTelephone2;
        this.contModel.contractorWebsite = data[0].contractorWebsite;
        this.contModel.webLogin = data[0].webLogin;
        this.contModel.contractorCode = data[0].contractorCode;
        this.contModel.contractorLogo = contractorLogo;
        this.contModel.userId = data[0].userId;
        this.contModel.appenateUser = data[0].appenateUser;
        this.contModel.appenateUserId = data[0].appenateUserId;
        this.contModel.reportEmail = data[0].reportEmail;

        //need to keep xxx password when existing weblogin = yes.
        this.password = ((this.contModel.userId != null && this.contModel.userId != "") || (this.contModel.appenateUserId != null && this.contModel.appenateUserId != "")) ? "xxxxxxxxxx" : "";
        this.loginFieldsDisabled = ((this.contModel.userId != null && this.contModel.userId != "") || (this.contModel.appenateUserId != null && this.contModel.appenateUserId != "")) ? true : false;
        this.passwordFieldsDisabled = this.loginFieldsDisabled;
        var jsonString = JSON.stringify(this.contModel);
        this.contModelOldData = JSON.parse(jsonString);
        this.onDropdownChange(true);
      }
      this.outpkTableId.emit(contId);
      this.btnName = "UPDATE";
      this.loading = false;

      //this.validateFormData();
    }, (errMsg) => {
      console.error("Error:  " + JSON.stringify(errMsg));
      this.loading = false;
    });
  }

  onCancel() {
    this.onClearFields();
    this.closeAddEditModlalPopup();
    if (!this.contractorConfiguration.addEditInModalPopUp) {
      this.appCode.scrollTo('panelGrid');
    }
  }

  // Email Validation using Pattern
  async onChangeEmail(newValue) {
    this.userNameValidationModel.isValid = true;
    this.emailValidationModel = await this.appCode.onEmailValidation(newValue, this.contractorConfiguration.requiredFeilds.contractorEmail);
  }

  onContractorDDLChange(event: any) {
    //pass pkTableId to child
    this.outpkTableId.emit(event.target.value);
  }

  // Password Pattern
  async validatePassword(event) {
    this.passwordValidationModel = await this.appCode.onPasswordValidation(event, true);
  }

  //Validate website Url
  async validateWebSiteUrl(event) {
    this.webSiteUrlValidationModel = await this.appCode.onWebsiteUrlValidation(event, this.contractorConfiguration.requiredFeilds.contractorWebsite);
  }

  ngModelChange() {
    this.validationModel.isContractorNameValid = true;
  }
  closeSelectContractorModlalPopup() {
    this.selectContractorSectionShowModal = false;
    this.selectContractorSectionShowModalClass = "modal fade";
  }
  openSelectContractorModlalPopup() {
    this.selectContractorSectionShowModal = true;
    this.selectContractorSectionShowModalClass = "modal fade in";
  }

  selectedRowChange(selectionEvent: SelectionEvent) {
    //let selectedItem = this.gridDataResult.data[selectionEvent.index];
    console.log(selectionEvent.selectedRows[0]);
    var res = selectionEvent.selectedRows[0].dataItem;
    this.contModel = res;


    this.outpkTableId.emit(this.contModel.tblContractorId.toString());
    this.closeSelectContractorModlalPopup();
  }

  closeAddContractorModlalPopup() {
    this.onClearFields();
    this.showModal = false;
    if (!this.contractorConfiguration.displayContractorDropDownList) this.appCode.scrollTo('panelGrid');
  }
  onDropdownChange(isEditLoad: boolean = false) {
    this.emailLabelText = "";//"Contractor Email ";
    this.passwordLabelText = "";//"Password for ";

    var msgTitle = "";
    var msgText = "";

    if (this.contModel.webLogin == "Yes" && this.contModelOldData.webLogin == "Yes") {
      this.emailLabelText = "(Username for Web-App)";
      this.passwordLabelText = "Web-App";
      this.passwordFieldsDisabled = true;
      this.password = "xxxxxxxxxx";
    }
    else if (this.contModel.webLogin == "No" && this.contModelOldData.webLogin == "No") {
      //no action needed
    }
    else if (this.contModel.webLogin == "Yes" && this.contModelOldData.webLogin == "No") {
      this.emailLabelText = "(Username for Web-App)";
      this.passwordLabelText = "Web-App";

      this.passwordFieldsDisabled = false;
      this.password = "";

      msgTitle += "Web-App";
      msgText += "Web-App";
    }
    else if (this.contModel.webLogin == "No" && this.contModelOldData.webLogin == "Yes") {
      //this.emailLabelText += " (Username for Web-App";
    }

    //Appenate
    if (this.contModel.appenateUser == "Yes" && this.contModelOldData.appenateUser == "Yes") {
      this.emailLabelText = (this.emailLabelText == "" ? "(Username for Mobile-App)" : "(Username for Web-App & Mobile-App)");
      if (this.contModel.webLogin == "Yes" && this.contModelOldData.webLogin == "Yes") {
        this.passwordLabelText = " Mobile-App";
      }
      else {
        this.passwordLabelText += (this.passwordLabelText == "" ? "Mobile-App" : " & Mobile-App");
      }
      this.passwordFieldsDisabled = true;
      this.password = "xxxxxxxxxx";
    }
    else if (this.contModel.appenateUser == "No" && this.contModelOldData.appenateUser == "No") {
      //no action needed
    }
    else if (this.contModel.appenateUser == "Yes" && this.contModelOldData.appenateUser == "No") {
      this.emailLabelText = (this.emailLabelText == "" ? "(Username for Mobile-App)" : "(Username for Web-App & Mobile-App)");

      if (this.contModel.webLogin == "Yes" && this.contModelOldData.webLogin == "Yes") {
        this.passwordLabelText = " Mobile-App";
      }
      else {
        this.passwordLabelText += (this.passwordLabelText == "" ? "Mobile-App" : " & Mobile-App");
      }

      this.passwordFieldsDisabled = false;
      this.password = "";

      msgTitle += (msgTitle == "" ? "Mobile-App" : " & Mobile-App");
      msgText += (msgText == "" ? "Mobile-App" : " & Mobile-App");
    }
    else if (this.contModel.appenateUser == "No" && this.contModelOldData.appenateUser == "Yes") {
      //this.emailLabelText += " (Username for Web-App";
    }

    this.emailLabelText = "Contractor Email " + this.emailLabelText;
    if (this.passwordLabelText != "") {
      this.passwordLabelText = "Password for " + this.passwordLabelText;
    }

    if (this.contModel.tblContractorId == 0 || this.contModel.tblContractorId == null) return false;
    if (msgTitle != "") {
      msgTitle = "New User Creation for " + msgTitle;
      msgText = "Please enter password for " + msgText;
      Swal.fire({
        title: msgTitle,
        text: msgText,
        showCancelButton: true,
        confirmButtonText: 'Yes',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'No',
        allowOutsideClick: false,
        width: 500,
      }).then((result) => {
        if (result.value === true) {
          this.password = "";
          this.passwordFieldsDisabled = false;
          $("#password").focus();
        }
        else if (result.dismiss) {
          if ((this.contModel.webLogin == "Yes" && this.contModelOldData.webLogin == "No")) {
            this.contModel.webLogin = "No";
          }
          if ((this.contModel.appenateUser == "Yes" && this.contModelOldData.appenateUser == "No")) {
            this.contModel.appenateUser = "No";
          }
          this.onDropdownChange();
          return false;
        }
      });
    }
  }

  onChangeTelephone(newValue: any, fieldName: string) {
    if (fieldName == "telephone1") {
      var data = this.appCode.validateFormatedText(newValue, this.contractorConfiguration.fieldsFormat.telephone1);
      this.contModel.contractorTelephone1 = data;
    }
    else if (fieldName == "telephone2") {
      var data = this.appCode.validateFormatedText(newValue, this.contractorConfiguration.fieldsFormat.telephone2);
      this.contModel.contractorTelephone2 = data;
    }
  }

  showInvoiceDetails(contractorId: string) {
    this.outpkTableId.emit(contractorId);
  }

  setContractorId(contractorId: string) {
    this.contractorConfiguration.selectedValueContractorDropDownList = contractorId;
  }

}
